import { Try } from "@/common";
import { IdType, PageDataType } from ".";
import { Notify } from "quasar";
import { api } from "@/plugins";

export type ProjectType = {
  id: number;
  userId: number;
  name: string;
  description: string;
  services: any;
  createdAt: string;
};

export type ProjectPartialType = Partial<ProjectType>;
export type ProjectPageDataType = PageDataType<ProjectType>;

const url = "project";

class ProjectService {
  @Try()
  async page(query: string) {
    const { data } = await api.get<ProjectPageDataType>(
      `/${url}/page?${query}`
    );

    return data;
  }

  @Try()
  async getById(id: number) {
    const { data } = await api.get<ProjectType>(`/${url}/${id}`);

    return data;
  }

  @Try()
  async search(q: string = "") {
    const { data } = await api.get<ProjectType[]>(`/${url}/search?q=${q}`);

    return data;
  }

  @Try({
    onSuccess() {
      Notify.create({
        color: "green",
        icon: "tag_faces",
        message: "Created successfully",
        position: "top-right",
      });
    },
    onError() {
      Notify.create({
        color: "red",
        icon: "sentiment_very_dissatisfied",
        message: "What went wrong",
        position: "top-right",
      });
    },
  })
  async create(project: ProjectType) {
    const { data } = await api.post<IdType>(`/${url}/`, project);

    return data;
  }

  @Try({
    onSuccess() {
      Notify.create({
        color: "secondary",
        icon: "tag_faces",
        message: "Luck updated",
        position: "top-right",
      });
    },
    onError() {
      Notify.create({
        color: "red",
        icon: "sentiment_very_dissatisfied",
        message: "What went wrong",
        position: "top-right",
      });
    },
  })
  async update(id: number, project: ProjectPartialType) {
    await api.patch(`/${url}/${id}`, project);
    return true;
  }

  async delete(id: number) {
    await api.delete(`/${url}/${id}`);
    return true;
  }
}

const projectService = new ProjectService();

export { projectService as ProjectService };
